// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactRelay from "react-relay";
import * as DecidrNodeId from "../../node-id/src/DecidrNodeId.bs.js";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.bs.js";
import * as RescriptRelay_Internal from "rescript-relay/src/RescriptRelay_Internal.bs.js";

function makeRefetchVariables(rowId, skipQuery, sourceViewId) {
  return {
          rowId: rowId,
          skipQuery: skipQuery,
          sourceViewId: sourceViewId
        };
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["View"]);
}

var variablesConverter = {"__root":{"sourceViewId":{"c":"DecidrNodeId.RelayAppSync"},"rowId":{"c":"DecidrNodeId.RelayAppSync"}}};

var variablesConverterMap = {
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.serialize
};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, variablesConverterMap, undefined);
}

var wrapResponseConverter = {"__root":{"node_View":{"f":""},"node":{"u":"response_node"}}};

var wrapResponseConverterMap = {
  response_node: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"node_View":{"f":""},"node":{"u":"response_node"}}};

var responseConverterMap = {
  response_node: unwrap_response_node
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: variablesConverterMap,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rowId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceViewId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "sourceViewId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coreConfig",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "View",
  "kind": "LinkedField",
  "name": "sourceView",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": "viewType",
      "args": null,
      "concreteType": "ViewType",
      "kind": "LinkedField",
      "name": "type",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  (v5/*: any*/)
],
v14 = [
  (v5/*: any*/),
  (v10/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mimetype",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SpacesBlockSystemLinkQuery",
    "selections": [
      {
        "condition": "skipQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "rowId",
                        "variableName": "rowId"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "SpacesBlockSystemLink_view"
                  }
                ],
                "type": "View",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpacesBlockSystemLinkQuery",
    "selections": [
      {
        "condition": "skipQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "callerRowId",
                        "variableName": "rowId"
                      }
                    ],
                    "concreteType": "ColumnView",
                    "kind": "LinkedField",
                    "name": "columnViews",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isHidden",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComponentType",
                        "kind": "LinkedField",
                        "name": "componentType",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageInfo",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TableLinkInfo",
                        "kind": "LinkedField",
                        "name": "tableLinkInfo",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ColumnLinkInfo",
                        "kind": "LinkedField",
                        "name": "columnLinkInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ColumnView",
                            "kind": "LinkedField",
                            "name": "referencedColumnView",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ColumnView",
                            "kind": "LinkedField",
                            "name": "primitiveColumnView",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TableLinkInfo",
                            "kind": "LinkedField",
                            "name": "tableLink",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Component",
                        "kind": "LinkedField",
                        "name": "component",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "rowId"
                      }
                    ],
                    "concreteType": "Row",
                    "kind": "LinkedField",
                    "name": "row",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v15/*: any*/),
                      (v9/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "cells",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isCell"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              }
                            ],
                            "type": "TextCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "number",
                                "storageKey": null
                              }
                            ],
                            "type": "NumberCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percent",
                                "storageKey": null
                              }
                            ],
                            "type": "PercentCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currency",
                                "storageKey": null
                              }
                            ],
                            "type": "CurrencyCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": "switched",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "switch",
                                "storageKey": null
                              }
                            ],
                            "type": "SwitchCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              }
                            ],
                            "type": "DateCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageInfo",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Size",
                                    "kind": "LinkedField",
                                    "name": "size",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "width",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "height",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ImageCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FileInfo",
                                "kind": "LinkedField",
                                "name": "audio",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "AudioCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FileInfo",
                                "kind": "LinkedField",
                                "name": "video",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "VideoCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FileInfo",
                                "kind": "LinkedField",
                                "name": "file",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "FileCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MultiSelectData",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SelectedRowInfo",
                                    "kind": "LinkedField",
                                    "name": "selectedRows",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Row",
                                        "kind": "LinkedField",
                                        "name": "row",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MultiSelectCell",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LookupCellData",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LookupCell",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "viewType",
                    "args": null,
                    "concreteType": "ViewType",
                    "kind": "LinkedField",
                    "name": "type",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "View",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fca6a86c767b7aec6e1598f3e6af069c",
    "id": null,
    "metadata": {},
    "name": "SpacesBlockSystemLinkQuery",
    "operationKind": "query",
    "text": "query SpacesBlockSystemLinkQuery(\n  $rowId: ID!\n  $sourceViewId: ID!\n  $skipQuery: Boolean!\n) {\n  node(id: $sourceViewId) @skip(if: $skipQuery) {\n    __typename\n    ... on View {\n      ...SpacesBlockSystemLink_view_bVORq\n    }\n    id\n  }\n}\n\nfragment SpacesAudioCell_audioCell on AudioCell {\n  audio {\n    ...SpacesFileInfo_fileInfo\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesBlockSystemLink_view_bVORq on View {\n  id\n  ...SpacesViewColumnViewRendererCommon_view_bVORq\n  columnViews(callerRowId: $rowId) {\n    ...SpacesCache_columnView\n    id\n    isHidden\n    columnId\n    name\n    componentType {\n      id\n      code\n    }\n  }\n  viewType: type {\n    id\n    code\n  }\n  coreConfig\n  row(id: $rowId) {\n    id\n    ...SpacesCache_row\n    ...SpacesRowListData_row\n  }\n}\n\nfragment SpacesCache_columnView on ColumnView {\n  columnId\n  isHidden\n}\n\nfragment SpacesCache_row on Row {\n  id\n  viewId\n}\n\nfragment SpacesCells_cell on Cell {\n  __isCell: __typename\n  __typename\n  ... on TextCell {\n    rowId\n    columnId\n    ...SpacesTextCell_textCell\n  }\n  ... on NumberCell {\n    rowId\n    columnId\n    ...SpacesNumberCell_numberCell\n  }\n  ... on PercentCell {\n    rowId\n    columnId\n    ...SpacesPercentCell_percentCell\n  }\n  ... on CurrencyCell {\n    rowId\n    columnId\n    ...SpacesCurrencyCell_currencyCell\n  }\n  ... on SwitchCell {\n    rowId\n    columnId\n    ...SpacesSwitchCell_switchCell\n  }\n  ... on DateCell {\n    rowId\n    columnId\n    ...SpacesDateCell_dateCell\n  }\n  ... on ImageCell {\n    rowId\n    columnId\n    ...SpacesImageCell_imageCell\n  }\n  ... on AudioCell {\n    rowId\n    columnId\n    ...SpacesAudioCell_audioCell\n  }\n  ... on VideoCell {\n    rowId\n    columnId\n    ...SpacesVideoCell_videoCell\n  }\n  ... on FileCell {\n    rowId\n    columnId\n    ...SpacesFileCell_fileCell\n  }\n  ... on MultiSelectCell {\n    rowId\n    columnId\n    ...SpacesMultiSelectCellCache_multiSelectCell\n    ...SpacesMultiSelectCellData_multiSelectCell\n  }\n  ... on LookupCell {\n    rowId\n    columnId\n    ...SpacesLookupCellCache_lookupCell\n    ...SpacesLookupCellData_lookupCell\n  }\n}\n\nfragment SpacesCurrencyCell_currencyCell on CurrencyCell {\n  currency\n  rowId\n  columnId\n}\n\nfragment SpacesDateCell_dateCell on DateCell {\n  date\n  rowId\n  columnId\n}\n\nfragment SpacesFileCell_fileCell on FileCell {\n  file {\n    ...SpacesFileInfo_fileInfo\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesFileInfo_fileInfo on FileInfo {\n  mimetype\n  size\n  url\n}\n\nfragment SpacesImageCell_imageCell on ImageCell {\n  image {\n    ...SpacesImageInfo_imageInfo\n    id\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesImageInfo_imageInfo on ImageInfo {\n  id\n  url\n  size {\n    width\n    height\n  }\n}\n\nfragment SpacesLookupCellCache_lookupCell on LookupCell {\n  rowId\n  columnId\n}\n\nfragment SpacesLookupCellData_lookupCell on LookupCell {\n  ...SpacesLookupCellCache_lookupCell\n  data {\n    __typename\n  }\n}\n\nfragment SpacesMultiSelectCellCache_multiSelectCell on MultiSelectCell {\n  rowId\n  columnId\n}\n\nfragment SpacesMultiSelectCellData_multiSelectCell on MultiSelectCell {\n  ...SpacesMultiSelectCellCache_multiSelectCell\n  data {\n    sourceView {\n      id\n      viewType: type {\n        code\n        id\n      }\n    }\n    selectedRows {\n      row {\n        ...SpacesCache_row\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment SpacesNumberCell_numberCell on NumberCell {\n  number\n  rowId\n  columnId\n}\n\nfragment SpacesPercentCell_percentCell on PercentCell {\n  percent\n  rowId\n  columnId\n}\n\nfragment SpacesRowListData_row on Row {\n  ...SpacesCache_row\n  id\n  cells {\n    __typename\n    ...SpacesCells_cell\n  }\n}\n\nfragment SpacesSwitchCell_switchCell on SwitchCell {\n  switched: switch\n  rowId\n  columnId\n}\n\nfragment SpacesTextCell_textCell on TextCell {\n  text\n  rowId\n  columnId\n}\n\nfragment SpacesVideoCell_videoCell on VideoCell {\n  video {\n    ...SpacesFileInfo_fileInfo\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesViewColumnViewRendererCommon_view_bVORq on View {\n  id\n  coreConfig\n  columnViews(callerRowId: $rowId) {\n    ...SpacesCache_columnView\n    isHidden\n    id\n    name\n    order\n    columnId\n    componentType {\n      id\n      name\n      code\n      icon {\n        url\n        id\n      }\n    }\n    tableLinkInfo {\n      id\n      sourceView {\n        id\n        viewType: type {\n          code\n          id\n        }\n      }\n    }\n    columnLinkInfo {\n      referencedColumnView {\n        id\n      }\n      primitiveColumnView {\n        id\n      }\n      tableLink {\n        id\n      }\n      id\n    }\n    component {\n      id\n      code\n    }\n  }\n  row(id: $rowId) {\n    ...SpacesCache_row\n    id\n    order\n    coreConfig\n    cells {\n      __typename\n      ...SpacesCells_cell\n    }\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

var wrap_response_node = RescriptRelay_Internal.wrapUnion;

export {
  Types ,
  unwrap_response_node ,
  wrap_response_node ,
  Internal ,
  Utils ,
  node ,
  load ,
  queryRefToObservable ,
  queryRefToPromise ,
}
/* node Not a pure module */
